import { TMDB_CONFIG } from "../constants/tmdb";

/** @typedef {import("../types").Movie} Movie */
/** @typedef {import("../types").Video} Video */

/** @param {Movie} movie @returns {string} */
export const getMovieTitle = (movie) => movie?.title || movie?.name || "Título no disponible";

/** @param {string} baseUrl @param {string} [path] @returns {string} */
export const getImageUrl = (baseUrl, path) => (path ? `${baseUrl}${path}` : "");

/** @param {Movie} movie @returns {string} */
export const getPosterUrl = (movie) => getImageUrl(TMDB_CONFIG.imageBaseUrl, movie?.poster_path);

/** @param {Movie} movie @returns {string} */
export const getBackdropUrl = (movie) => getImageUrl(TMDB_CONFIG.imageBaseUrl, movie?.backdrop_path);

/** @param {Movie} movie @returns {string} */
export const getMovieReleaseYear = (movie) => {
  const rawDate = movie?.release_date || movie?.first_air_date;
  if (!rawDate) return "Año no disponible";

  // TMDB manda fechas "YYYY-MM-DD" sin hora/zona; extraemos el año del string
  // directamente para no depender de cómo Date() lo reinterprete en la zona
  // horaria local (podía correr el año en zonas detrás de UTC).
  const match = /^(\d{4})-\d{2}-\d{2}/.exec(rawDate);
  return match ? match[1] : "Año no disponible";
};

/** @param {Movie} movie @returns {string|null} */
export const getMovieRating = (movie) => {
  const rating = movie?.vote_average;
  return typeof rating === "number" && rating > 0 ? rating.toFixed(1) : null;
};

/** @param {Video[]} [videos] @returns {Video|null} */
export const getOfficialTrailer = (videos = []) => {
  const official = videos.find(
    (video) => video.type === "Trailer" && /official/i.test(video.name)
  );

  if (official) return official;

  return videos.find((video) => video.type === "Trailer") || videos[0] || null;
};
